import { CircularProgressWithLabel } from "../../../../../../components/Loading/CircularProgressWithLabel";

// Date formatting function from task module
const convertDateString = (dateString) => {
  if (!dateString) return "";
  const dateObject = new Date(dateString);
  const formattedDate = `${dateObject.getDate()}-${dateObject.toLocaleString(
    "en-US",
    { month: "short" }
  )}-${dateObject.getFullYear()}`;
  return <p>{formattedDate}</p>;
};

// Helper function to calculate progress based on MRQ, PO, MRV status
const calculateProgress = (material) => {
  const hasMrq = material.mrqMaterials?.[0]?.mrq?.id;
  const hasPo = material.mrqMaterials?.[0]?.poId || 
                material.mrqMaterials?.[0]?.poMaterials?.[0]?.po?.id;
  const hasMrv = material.mrvMaterials?.[0]?.id || 
                 material.mrqMaterials?.[0]?.mrvMrqMaterials?.[0]?.mrv?.id;

  if (hasMrv) return 100;
  if (hasPo) return 60;
  if (hasMrq) return 30;
  return 0;
};

// Helper function to get cost from PO
const getCost = (material) => {
  return material.mrqMaterials?.[0]?.poMaterials?.[0]?.cost || 
         material.mrqMaterials?.[0]?.cost || 
         null;
};

export const schedule4DColumns = [
  // {
  //   accessorKey: "drawingTitle",
  //   header: "Drawing Title",
  //   enableEditing: false,
  //   size: 150,
  //   Cell: ({ row }) => {
  //     return row.original.drawing?.title || "-";
  //   },
  // },
  // {
  //   accessorKey: "drawingNumber",
  //   header: "Drawing #",
  //   enableEditing: false,
  //   size: 120,
  //   Cell: ({ row }) => {
  //     return row.original.drawing?.dwgNumber || "-";
  //   },
  // },
  // {
  //   accessorKey: "revision",
  //   header: "Revision",
  //   enableEditing: false,
  //   size: 80,
  //   Cell: ({ row }) => {
  //     return row.original.drawing?.revision || "-";
  //   },
  // },
  // {
  //   accessorKey: "tagNumber",
  //   header: "Tag #",
  //   enableEditing: false,
  //   size: 100,
  //   Cell: ({ row }) => {
  //     const m = row.original;
  //     return m?.tagNumber || m?.taggedMaterial?.tagNumber || m?.item || "-";
  //   },
  // },
  {
    header: "Description",
    accessorKey: "description",
    enableEditing: false,
    size: 250,
    Cell: ({ row }) => {
      const m = row.original;
      return m.description
        ? m.description
        : m.taggedMaterial
          ? `${m.taggedMaterial?.component || ""} ${m.taggedMaterial?.size || ""}`.trim()
          : "-";
    },
  },
  {
    accessorKey: "baselineStart",
    header: `Baseline Start`,
    size: 120,
    enableColumnFilter: false,
    enableEditing: true,
    Cell: ({ cell }) => {
      const dateValue = cell.getValue() || 
                       cell.row.original.mrqMaterials?.[0]?.mrq?.createdAt ||
                       cell.row.original.mrqMaterials?.[0]?.createdAt;
      return dateValue ? (
        <div style={{ whiteSpace: "wrap" }}>
          {convertDateString(dateValue)}
        </div>
      ) : (
        ""
      );
    },
    muiEditTextFieldProps: ({ cell }) => {
      const dateValue = cell.getValue() || 
                       cell.row.original.mrqMaterials?.[0]?.mrq?.createdAt ||
                       cell.row.original.mrqMaterials?.[0]?.createdAt;
      // Convert date to YYYY-MM-DD format for date input
      const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        try {
          const date = new Date(dateString);
          if (isNaN(date.getTime())) return "";
          return date.toISOString().split('T')[0];
        } catch {
          return "";
        }
      };
      return {
        type: "date",
      };
    },
  },
  {
    accessorKey: "baselineEnd",
    header: `Baseline End`,
    size: 120,
    enableColumnFilter: false,
    enableEditing: true,
    Cell: ({ cell }) => {
      const dateValue = cell.getValue() || 
                       cell.row.original.mrqMaterials?.[0]?.poMaterials?.[0]?.time ||
                       cell.row.original.mrqMaterials?.[0]?.poMaterials?.[0]?.po?.createdAt;
      return dateValue ? (
        <div style={{ whiteSpace: "wrap" }}>
          {typeof dateValue === 'string' && dateValue.includes('Days') 
            ? dateValue 
            : convertDateString(dateValue)}
        </div>
      ) : (
        ""
      );
    },
    muiEditTextFieldProps: ({ cell }) => {
      return {
        type: "date",
      };
    },
  },
  {
    accessorKey: "revisedStart",
    header: `Revised Start`,
    size: 120,
    enableColumnFilter: false,
    enableEditing: true,
    Cell: ({ cell }) => {
      const dateValue = cell.getValue() || 
                       cell.row.original.mrqMaterials?.[0]?.poMaterials?.[0]?.po?.createdAt;
      return dateValue ? (
        <div style={{ whiteSpace: "wrap" }}>
          {convertDateString(dateValue)}
        </div>
      ) : (
        ""
      );
    },
    muiEditTextFieldProps: ({ cell }) => {
      return {
        type: "date",
      };
    },
  },
  {
    accessorKey: "revisedEnd",
    header: `Revised End`,
    size: 120,
    enableColumnFilter: false,
    enableEditing: true,
    Cell: ({ cell }) => {
      const dateValue = cell.getValue() || 
                       cell.row.original.mrvMaterials?.[0]?.createdAt ||
                       cell.row.original.mrqMaterials?.[0]?.mrvMrqMaterials?.[0]?.mrv?.createdAt;
      return dateValue ? (
        <div style={{ whiteSpace: "wrap" }}>
          {convertDateString(dateValue)}
        </div>
      ) : (
        ""
      );
    },
    muiEditTextFieldProps: ({ cell }) => {
      return {
        type: "date",
      };
    },
  },

  {
    header: "Quantity",
    accessorKey: "quantity",
    enableEditing: false,
    size: 100,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ row }) => {
      const qty = row.original?.quantity;
      function formatNumber(num) {
        if (num === null || num === undefined) return "-";
        return Number.isInteger(num) ? num : num.toFixed(2);
      }
      return formatNumber(Number(qty));
    },
  },
  // {
  //   header: "Unit",
  //   accessorKey: "unit",
  //   enableEditing: false,
  //   size: 80,
  //   muiTableHeadCellProps: {
  //     align: "center",
  //   },
  //   muiTableBodyCellProps: {
  //     align: "center",
  //   },
  //   Cell: ({ row }) => {
  //     return row.original?.unit || "Nos";
  //   },
  // },
  {
    header: "MRQ Status",
    accessorKey: "mrqStatus",
    enableEditing: false,
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ row }) => {
      const hasMrq = row.original.mrqMaterials?.[0]?.mrq?.id;
      return hasMrq ? (
        <span style={{ color: "green", fontWeight: "bold" }}>✓ MRQ</span>
      ) : (
        <span style={{ color: "gray" }}>-</span>
      );
    },
  },
  {
    header: "PO Status",
    accessorKey: "poStatus",
    enableEditing: false,
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ row }) => {
      const hasPo = row.original.mrqMaterials?.[0]?.poId || 
                   row.original.mrqMaterials?.[0]?.poMaterials?.[0]?.po?.id;
      return hasPo ? (
        <span style={{ color: "green", fontWeight: "bold" }}>✓ PO</span>
      ) : (
        <span style={{ color: "gray" }}>-</span>
      );
    },
  },
  {
    header: "MRV Status",
    accessorKey: "mrvStatus",
    enableEditing: false,
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ row }) => {
      const hasMrv = row.original.mrvMaterials?.[0]?.id || 
                     row.original.mrqMaterials?.[0]?.mrvMrqMaterials?.[0]?.mrv?.id;
      return hasMrv ? (
        <span style={{ color: "green", fontWeight: "bold" }}>✓ MRV</span>
      ) : (
        <span style={{ color: "gray" }}>-</span>
      );
    },
  },
  {
    header: "Progress",
    accessorKey: "progress",
    enableEditing: false,
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ row }) => {
      const progress = calculateProgress(row.original);
      return <CircularProgressWithLabel value={progress} />;
    },
  },
  {
    accessorKey: "budgetedCost",
    header: "Budgeted Cost ($)",
    enableEditing: true,
    size: 130,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      if (value === null || value === undefined || value === "") {
        return <span style={{ color: "gray" }}>-</span>;
      }
      return `$${Number(value).toFixed(2)}`;
    },
    muiEditTextFieldProps: {
      type: "number",
      inputProps: {
        step: 0.01,
        min: 0,
      },
    },
  },
  {
    accessorKey: "cost",
    header: "Cost ($)",
    enableEditing: false,
    size: 120,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ row }) => {
      const cost = getCost(row.original);
      const hasPo = row.original.mrqMaterials?.[0]?.poId || 
                   row.original.mrqMaterials?.[0]?.poMaterials?.[0]?.po?.id;
      
      // Only show cost if PO exists
      if (!hasPo) {
        return <span style={{ color: "gray" }}>-</span>;
      }
      
      if (cost === null || cost === undefined) {
        return <span style={{ color: "gray" }}>-</span>;
      }
      
      return `$${Number(cost).toFixed(2)}`;
    },
  },
];

